/**
 * True when a failed request means "your role may not use this": an HTTP 401
 * or 403, read from the thrown error's `status` (our API clients), an axios
 * style `response.status`, or a bare "forbidden" / "unauthorized" message
 * from clients that only keep the server text.
 */
const isAccessDeniedError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') {
    return (
      typeof error === 'string' && /forbidden|unauthori[sz]ed/i.test(error)
    );
  }
  const e = error as {
    status?: unknown;
    response?: { status?: unknown };
    message?: unknown;
  };
  const status = Number(e.status ?? e.response?.status);
  if (status === 401 || status === 403) return true;
  return (
    typeof e.message === 'string' &&
    /forbidden|unauthori[sz]ed/i.test(e.message)
  );
};

export default isAccessDeniedError;
